/**
 * Stands in for a section or value we can't fill yet, so the gap is visible
 * on the page instead of the section quietly missing. Styled like the
 * mockup's callouts: a divider, a lead line saying what's missing, and
 * optionally a quieter line saying why.
 */

export function Gap({ title, reason }: { title: string; reason?: string }) {
  return (
    // role="note": screen readers announce it as a side note, not page content
    <div role="note" className="border-t border-si-line px-1 pt-[18px]">
      {/* What's missing */}
      <p className="m-0 max-w-[62ch] text-si-lg font-medium leading-[1.4] tracking-[-0.015em]">
        {title}
      </p>
      {/* Why, and what it's waiting on; left out when no reason is given */}
      {reason && <p className="mt-1.5 text-si-md text-si-ink-2">{reason}</p>}
    </div>
  );
}
